module.exports = __webpack_public_path__ + "static/img/join_img1.5be11a2b.jpeg";